import React from 'react';
import { bool, shape, string } from 'prop-types';

const CheckList = ({
  className = 'icon',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5 5.24977H9.75V6.74977H16.5V5.24977ZM16.5 11.2498H9.75V12.7498H16.5V11.2498ZM4.155 8.24977L1.5 5.59477L2.5575 4.53727L4.1475 6.12727L7.3275 2.94727L8.385 4.00477L4.155 8.24977ZM4.155 14.2498L1.5 11.5948L2.5575 10.5373L4.1475 12.1273L7.3275 8.94727L8.385 10.0048L4.155 14.2498Z" fill="currentColor" />
  </svg>
);

CheckList.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default CheckList;
